import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  list: theme => css`
    list-style: disc;
    margin-left: ${theme.spacing.sm};
    li {
      ${theme.typography.paragraphLarge};
      color: ${theme.colors.neutral[400]};
    }
  `,
})

export default useStyles
